import { DatePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FiltersComponent, SearchUsersService, SearchUser } from 'reg-hub-common';

@Component({
  selector: 'app-search-users-filter',
  templateUrl: './search-users-filter.component.html',
  styleUrl: './search-users-filter.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchUsersFilterComponent extends FiltersComponent<SearchUser> implements OnInit {
  constructor(
    searchUsersService: SearchUsersService,
    formBuilder: FormBuilder,
    datePipe: DatePipe) {
    super(searchUsersService, formBuilder, datePipe);
  }
  
  ngOnInit(): void {
    this._filterForm = this.formBuilder.group({
      isActive: [true],
      username: [null],
      firstName: [null],
      middleName: [null],
      lastName: [null],
      email: [null]
    });

    // this.repo.getFirstPage();
  }

}